import { useContext } from "react";
import { DAYS } from "components/common/Graph/types";
import GraphDaysContext from "components/common/Graph/contexts/GraphDaysContext";
const useGraphDays = () => {
  try {
    const context = useContext(GraphDaysContext);
    if (!context) {
      throw new Error("useGraphDays must be used within a GraphDaysContextProvider");
    }
    return context;
  } catch {
    return { graphDays: DAYS[0], setGraphDays: () => void 0 };
  }
};
export default useGraphDays;
